const o="CHAT_FILES";export{o as CHAT_FILE_CATEGORY};